import { render, staticRenderFns } from "./afterSaleWaitApproveRouter.vue?vue&type=template&id=1156d615&scoped=true&"
import script from "./afterSaleWaitApproveRouter.vue?vue&type=script&lang=js&"
export * from "./afterSaleWaitApproveRouter.vue?vue&type=script&lang=js&"
import style0 from "./afterSaleWaitApproveRouter.vue?vue&type=style&index=0&id=1156d615&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1156d615",
  null
  
)

export default component.exports